export default "__VITE_ASSET__D6wy5FXa__"